import { buildCareEntryTitle, isUsableCareEntryTitleHint } from '../../shared/careEntryTitles';

const normalizeText = (value) => String(value || '').trim();

const getTitleWordCount = (value = '') => normalizeText(value).split(/\s+/).filter(Boolean).length;

const isSentenceLikeTitle = (title = '', body = '') => {
  const normalizedTitle = normalizeText(title);
  if (!normalizedTitle) {
    return false;
  }

  const normalizedBody = normalizeText(body).toLowerCase();
  const lowerTitle = normalizedTitle.toLowerCase();
  return normalizedTitle.length > 48
    || getTitleWordCount(normalizedTitle) > 7
    || /[.!?]/.test(normalizedTitle)
    || Boolean(normalizedBody && normalizedBody !== lowerTitle && normalizedBody.startsWith(lowerTitle));
};

export const resolveCaptureFirstDisplayTitle = ({
  displayTitle = '',
  bodyText = '',
  category = 'log',
  captureFirstDetails = {},
} = {}) => {
  if (!captureFirstDetails?.enabled || !isSentenceLikeTitle(displayTitle, bodyText)) {
    return displayTitle;
  }

  const firstBucketLabel = normalizeText(captureFirstDetails.storyBuckets?.[0]?.label);
  if (isUsableCareEntryTitleHint(firstBucketLabel, category, bodyText)) {
    return firstBucketLabel;
  }

  return buildCareEntryTitle(category, bodyText);
};
